import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { connect } from 'react-redux';
import { fetchOrdenesEnVerde, setFiltroOrdenes } from '../../../actions/ordenesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import OrdenProvListItem from './OrdenProvListItem';
import { filtroUnaSemana } from '../../../utilities/fechasFiltro';
import BigSpinner from "../../General/BigSpinner";
import FiltroOrdenes from '../FiltroOrdenesProveedores';
const fechaFiltro = filtroUnaSemana();


class ListOrdenesProv extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            onFilter: true,
            request: {
                idUsuario: this.props.tipoUsuario == 7 ? this.props.userId : "",
                cantidadPagina: 10,
                numeroPagina: 1,
                documento: "",
                idOrden: "",
                idEstado: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                fechaModific: "",
                skuMarket: "",
                idTipoPlataforma: null,
                idOrdenDesde: null,
                idOrdenHasta: null
            }
        };
    }

    componentDidMount() {

        let estadoInicioFiltraPor_Moderador = { 
            ...this.state.request,
            idUsuario: ""
        };

        let request = this.props.filtro;

        if (this.props.emptyFiltro.ordenes) {
            if (this.props.tipoUsuario === 2 || this.props.tipoUsuario === 6) {
                this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                this.setState({ request: estadoInicioFiltraPor_Moderador })
                this.props.fetchOrdenesEnVerde(estadoInicioFiltraPor_Moderador);
            } else {
                this.props.setFiltroOrdenes(this.state.request);
                this.props.fetchOrdenesEnVerde(this.state.request);
            }
        } else {
            request.numeroPagina = 1;
            this.props.setFiltroOrdenes(request);
            this.setState({ request: request });
            this.props.fetchOrdenesEnVerde(request);
        }

        if (this.props.tipoUsuario === 2 || this.props.tipoUsuario === 6) { 
            this.props.fetchSellersFilter(null); 
        }
    }

    setFilter = (event) => {
        event.preventDefault();
        this.setState({ onFilter: !this.state.onFilter });
    }

    setModerador = () => {
        this.props.setRoleModerador(this.props.tipoUsuario !== 2);
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        let params = {};
        if (this.props.tipoUsuario === 2 || this.props.tipoUsuario === 6) {
            params = {
               ...this.state.request,
               numeroPagina: selectedPage
            }
        } else {
            params = {
               ...this.state.request,
                idUsuario: this.props.userId,
               numeroPagina: selectedPage
            }
        }
        
        this.setState({
            request: params,
            numeroPagina: selectedPage
        });
        
        this.updateRequest(params);
    };
    
    updateRequest = (request) => {
        
        let params = {
            ...this.state,
            request: request
        }
        
        if (this.props.tipoUsuario !== 2 && this.props.tipoUsuario !== 6) {
            request.idUsuario = this.props.userId;
            params = {
                ...this.state,
                request: request
            }
        }
        
        this.setState({
            request: params.request,
            currentPage: params.request.numeroPagina
        });

        this.props.setFiltroOrdenes(params.request);
        this.props.fetchOrdenesEnVerde(params.request);
    }

    
    render() {
        const { ordenes } = this.props;
        let elementos = ordenes.elementos === undefined ? [] : ordenes.elementos;

        return (
            <div className="container">

                <div className="row justify-content-between align-items-center page-titles text-center text-md-start">

                    <div className="col-12 col-md-auto mb-md-0 mb-2">
                        <h3 className="text-themecolor color-rojo-megatone">Órdenes Proveedores</h3>
                    </div>

                    <div className="col-12 col-md-auto d-inline text-center text-md-end mt-md-0 mt-2">
                        <button 
                            type="button" 
                            onClick={this.setFilter} 
                            className="btn btn-sm background-rojo-megatone"
                        >
                            <i className="fa fa-filter"/> {this.state.onFilter ?  "Ocultar" : "Mostrar Filtro"}
                        </button>
                    </div>

                </div>

                <div hidden={!this.state.onFilter}>
                    <FiltroOrdenes 
                        filtro={this.props.filtro} 
                        updateRequest={this.updateRequest} 
                        tipoUsuario={this.props.tipoUsuario}
                        allowSearchBySeller={false}
                    />
                </div>

                <div hidden={!this.props.loadingOrdenes}>
                    <BigSpinner />
                </div>

                <div hidden={elementos.length > 0 || this.props.loadingOrdenes}>
                    <h5 className="d-flex justify-content-center my-4">
                        NO SE ENCONTRARON RESULTADOS
                    </h5>
                </div>

                <div className="list-group" hidden={this.props.loadingOrdenes}>
                    {elementos.length > 0 ? elementos.map((orden, index) => {

                        if (this.props.tipoUsuario !== 2){
                        return (
                            <div key={index}>
                                <OrdenProvListItem
                                    mailCliente={""}
                                    idOrden={orden.idOrden}
                                    fecha={orden.fecha}
                                    cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                    documento={orden.cliente.documento}
                                    tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                    montoVenta={orden.montoVenta}
                                    productos={orden.productos}
                                    anulacionMegatone={orden.anulacionMegatone}
                                    obleaDescargada={orden.obleaDescargada}
                                    comprobante={orden.comprobante}
                                    userId={this.props.userId}
                                />
                            </div>
                        )} 
                        else if (this.props.tipoUsuario === 2 || this.props.tipoUsuario === 6) {
                            return (
                                <a key={index}>
                                    <OrdenProvListItem
                                        mailCliente={orden.cliente.email}
                                        idOrden={orden.idOrden}
                                        key={index}
                                        fecha={orden.fecha}
                                        cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                        documento={orden.cliente.documento}
                                        tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                        montoVenta={orden.montoVenta}
                                        productos={orden.productos}
                                        dniIdBocaSeller={orden.idVendedorBoca}
                                        plataformaCodigo={orden.plataforma.codigo}
                                        anulacionMegatone={orden.anulacionMegatone}
                                        obleaDescargada={orden.obleaDescargada}
                                        comprobante={orden.comprobante}
                                        userId={this.props.userId}
                                    />
                                </a>
                            )
                        }
                    }) : null
                }
                </div>

                <div className="d-flex justify-content-center">
                    <ReactPaginate 
                        previousLabel={"Anterior"} 
                        nextLabel={"Siguiente"} 
                        breakLabel={"..."} 
                        breakClassName={"break-me"} 
                        pageCount={this.props.ordenes.cantidadTotal / this.state.request.cantidadPagina} 
                        marginPagesDisplayed={5} 
                        pageRangeDisplayed={this.state.request.cantidadPagina} 
                        onPageChange={this.handlePageClick} 
                        containerClassName={"pagination"} 
                        subContainerClassName={"pages pagination"} 
                        activeClassName={"active"} 
                        forcePage={this.state.currentPage - 1}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    ordenes: state.ordenes.ordenesEnVerde,
    filtro: state.ordenes.filtro,
    userId: state.general.userId
});

export default connect(mapStateToProps, { 
    fetchOrdenesEnVerde,
    limpiarFiltros, 
    setFiltroOrdenes, 
    fetchSellersFilter 
}) (ListOrdenesProv);